import { render } from "./validationErrors.vue?vue&type=template&id=c7a124f0"
import script from "./validationErrors.vue?vue&type=script&lang=js"
export * from "./validationErrors.vue?vue&type=script&lang=js"

import "./validationErrors.vue?vue&type=style&index=0&id=c7a124f0&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__